"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignStorageFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var CampaignStorageFactory = /** @class */ (function (_super) {
    __extends(CampaignStorageFactory, _super);
    function CampaignStorageFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    CampaignStorageFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    CampaignStorageFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    CampaignStorageFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    CampaignStorageFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    CampaignStorageFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return CampaignStorageFactory;
}(contracts_1.ContractFactory));
exports.CampaignStorageFactory = CampaignStorageFactory;
var _abi = [
    {
        inputs: [],
        name: "BASE",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "arcDAO",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "daoAllocation",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getRewardForDuration",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lastUpdateTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "periodFinish",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rewardPerTokenStored",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rewardRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rewardToken",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rewardsDistributor",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rewardsDuration",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "stakingToken",
        outputs: [
            {
                internalType: "contract IPermittableERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "tokensClaimable",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "userAllocation",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "0x608060405260006003556000600455600060075534801561001f57600080fd5b506103be8061002f6000396000f3fe608060405234801561001057600080fd5b50600436106100f55760003560e01c80637b0a47ee11610097578063df136d6511610066578063df136d65146101b8578063ebe2b12b146101c1578063ec342ad0146101ca578063f7c618c1146101d957600080fd5b80637b0a47ee14610195578063886140be1461019e5780639af71b79146101a7578063c8f33c91146101af57600080fd5b8063386a9525116100d3578063386a95251461013b5780633f2a5540146101445780636d156ef21461016f57806372f702f31461018257600080fd5b806318160ddd146100fa5780631c1f78eb1461011657806331f684c01461011e575b600080fd5b610103600b5481565b6040519081526020015b60405180910390f35b6101036101ec565b600a5461012b9060ff1681565b604051901515815260200161010d565b61010360045481565b600854610157906001600160a01b031681565b6040516001600160a01b03909116815260200161010d565b600054610157906001600160a01b031681565b600254610157906001600160a01b031681565b61010360075481565b61010360095481565b61010361020a565b61010360065481565b61010360055481565b61010360035481565b610103670de0b6b3a764000081565b600154610157906001600160a01b031681565b600061020560045460075461022990919063ffffffff16565b905090565b6000610205600954670de0b6b3a76400006102b690919063ffffffff16565b600082610238575060006102b0565b6000610244838561033c565b905082610251858361031c565b146102ad5760405162461bcd60e51b815260206004820152602160248201527f536166654d6174683a206d756c7469706c69636174696f6e206f766572666c6f6044820152607760f81b60648201526084015b60405180910390fd5b90505b92915050565b6000828211156103085760405162461bcd60e51b815260206004820152601e60248201527f536166654d6174683a207375627472616374696f6e206f766572666c6f77000060448201526064016102a4565b6000610314838561035b565b949350505050565b60008261033757634e487b7160e01b81526012600452602481fd5b500490565b600081600019048311821515161561035657610356610372565b500290565b60008282101561036d5761036d610372565b500390565b634e487b7160e01b600052601160045260246000fdfea26469706673582212200c7bc1c894653496b1e7849a38671042fd249bd314e9cbbc37edc9960dfe147664736f6c63430008040033";
